import clsx from 'clsx';
import React from 'react';

const Badge = ({ children, className, ...props }) => (
  <div
    className={clsx(
      className,
      'inline-block font-bold self-center text-xs rounded py-[0.15em] px-2',
    )}
    {...props}
  >
    {children}
  </div>
);

export default Badge;
